<template>
  <label
    :for="id"
    class="bl-input-label transition-all duration-300"
    :class="{
      'bl-input-label-checked bl-input-color-primary':
        (checked || indeterminate) && color === 'primary',
      'bl-input-label-checked bl-input-color-lime':
        (checked || indeterminate) && color === 'lime',
      'opacity-75': !checked && !indeterminate,
      'bl-input-label-disabled cursor-not-allowed pointer-events-none': disabled,
      'cursor-wait': loading
    }"
  >
    <input
      type="checkbox"
      class="bl-input"
      :class="{
        'cursor-not-allowed pointer-events-none': disabled,
        'cursor-wait pointer-events-none': loading
      }"
      :id="id"
      @change="change"
    />
    <div
      class="bl-input-dot"
      :class="{ 'cursor-not-allowed': disabled, 'cursor-wait': loading }"
    ></div>
    <div v-if="tooltip" class="bl-input-tooltip">
      <BlTextBody3 class="bl-input-tooltip-text" :text="tooltip" />
    </div>
  </label>
</template>

<script>
import BlIcon from "./BlIcon.vue";
import BlTextBody3 from "./BlTextBody3.vue";

export default {
  components: {
    BlIcon,
    BlTextBody3
  },
  name: "BlButton",
  props: {
    color: { type: String, default: "primary" },
    checked: { type: Boolean, default: false },
    indeterminate: { type: Boolean, default: false },
    tooltip: { type: String, required: false },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  computed: {
    id() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
      let combination = "";
      for (let i = 0; i < 6; i++) {
        combination += chars[Math.round(Math.random() * 35)];
      }
      return `bl-input-${combination}`;
    }
  },
  methods: {
    change() {
      if (!this.disabled && !this.loading) {
        this.$emit("changed", this.checked);
      }
    }
  }
};
</script>

<style scoped lang="scss">
label.bl-input-label {
  cursor: pointer;
  position: relative;
  width: 2rem;
  height: 1.125rem;
  border-radius: 0.5625rem;
  background: var(--border-color);
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  input.bl-input {
    pointer-events: none;
    z-index: -1;
    position: absolute;
    opacity: 0;
  }
  .bl-input-dot {
    position: absolute;
    top: 0.1875rem;
    left: 0.1875rem;
    width: 0.75rem;
    height: 0.75rem;
    border-radius: 50%;
    background: var(--background-depth-one-color);
    transition-property: all;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
    transition-duration: 300ms;
  }
  .bl-input-tooltip {
    pointer-events: none;
    opacity: 0;
    position: absolute;
    top: calc(100% + 0.5rem);
    left: 50%;
    width: 8.375rem;
    padding: 0.75rem 1rem;
    box-sizing: border-box;
    background: var(--primary-color);
    border-radius: 10px;
    transform: translateX(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    .bl-input-tooltip-text {
      color: #fff;
      text-align: center;
    }
    &::before {
      content: "";
      position: absolute;
      bottom: 99%;
      left: 50%;
      margin-left: -0.5rem;
      border-width: 0.5rem;
      border-style: solid;
      border-color: transparent transparent var(--primary-color) transparent;
    }
  }
  &.bl-input-label-disabled {
    cursor: default;
    background-color: var(--border-color);
  }
  &.bl-input-label-checked {
    .bl-input-dot {
      left: 1.0625rem;
    }
  }
  &.bl-input-color-primary {
    background: var(--primary-color);
  }
  &.bl-input-color-lime {
    background: var(--Lime-Lime-7, #789719);
  }
  &:hover {
    z-index: 99;
    .bl-input-tooltip {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/BlInputToggle.vue